import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const featureRows = [
  { feature: "No ads for you and your readers", guest: "✅", premium: "✅" },
  { feature: "No Captcha during adding notes", guest: "✅", premium: "✅" },
  { feature: "4 Free Publish pages with liftime validity", guest: "❌", premium: "✅" },
  { feature: "Get Custom Name of your Live Page", guest: "❌", premium: "✅" },
  { feature: "Live Pages with no Ads", guest: "❌", premium: "✅" },
  { feature: "Get 500+ Backlinks from High DA Website", guest: "✅", premium: "✅" },
  { feature: "Preserve you text on the webiste for 1 year", guest: "❌", premium: "✅" },
];

const FeatureTable = () => {
  const theme = useTheme();

  return (
    <TableContainer component={Paper} sx={{ marginTop: 4, borderRadius: 3 }}>
      <Table>
        <TableHead sx={{ backgroundColor: theme.palette.secondary.main }}>
          <TableRow>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Features</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Guest</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Premium</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {featureRows.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.feature}</TableCell>
              <TableCell>{row.guest}</TableCell>
              <TableCell>{row.premium}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FeatureTable;
